module.exports = __webpack_public_path__ + "img/galaxy.9c4a3ae2.webp";